import {getAnalytics, logEvent} from "firebase/analytics";

export function userVisitedAboutMe() {
  const analytics = getAnalytics();
  logEvent(analytics, 'about_me_view', {});
}

export function userVisitedProjects() {
  const analytics = getAnalytics();
  logEvent(analytics, 'projects_view', {});
}

export function userVisitedHome() {
  const analytics = getAnalytics();
  logEvent(analytics, 'home_view', {});
}

export function userClickedOnLinkedIn() {
  const analytics = getAnalytics();
  logEvent(analytics, 'clicked_linkedin', {});
}

export function userClickedOnGithub() {
  const analytics = getAnalytics();
  logEvent(analytics, 'clicked_github', {});
}
